module.exports = __webpack_public_path__ + "static/media/instagram.88504839.svg";


//////////////////
// WEBPACK FOOTER
// ./src/social/instagram.svg
// module id = 26
// module chunks = 0